export const WIDGET_SERIES_DEFAULT_COLORS: string[] = [
  '#3B82F6', // azul
  '#10B981', // verde esmeralda
  '#F59E0B', // amarillo ámbar
  '#EF4444', // rojo
  '#8B5CF6', // violeta
  '#06B6D4', // cian
  '#F97316', // naranja
  '#84CC16', // lima
  '#EC4899', // rosa
  '#14B8A6', // verde azulado
  '#F43F5E', // rosa intenso
  '#A855F7', // púrpura
  '#0EA5E9', // azul cielo
  '#22C55E', // verde
  '#EAB308', // amarillo
  '#6366F1', // índigo
  '#E11D48', // carmesí
  '#0D9488', // verde azulado oscuro
  '#D97706', // naranja oscuro
  '#7C3AED', // violeta oscuro
];

export const WIDGET_NUMBER_DEFAULT_COLOR = '#374151';
export const WIDGET_LIST_DEFAULT_COLOR   = '#64748b';
